<script setup></script>

<template>
    <div class="row">
        <div class="col-12">

            <div v-if="errored">
                <Error :envARLDE="envARLDE" />
                <ButtonReturnSite :lienRetourSite="lienRetourSite" :envARLDE="envARLDE"/>
            </div>

            <div v-if="erroredSend">
                <Error :envARLDE="envARLDE" />
                <ButtonReturnSite :lienRetourSite="lienRetourSite" :envARLDE="envARLDE"/>
            </div>

            <div v-if="loading && !dataSend">
                <h4 v-if="!envARLDE">
                    Chargement ...
                </h4>
                <h4 v-if="envARLDE">
                    Laden...
                </h4>
            </div>

            <div v-if="dataSend && !erroredSend"> 
                <h4>
                    Vos données ont bien été enregistrées
                    <ButtonReturnSite :lienRetourSite="lienRetourSite" :envARLDE="envARLDE"/>

                </h4>
            </div>

            <form v-if="!dataSend && !errored && !loading" id="arm-form-desabo" @submit.prevent="submitForm" @submit="postData">

                <h4 id="arm-first-title" v-if="!envARLDE" >Je souhaite recevoir par email :</h4>
                <h4 id="arm-first-title" v-if="envARLDE"> Ich möchte per E-Mail erhalten : </h4>


                <!--FORM EMAIL -->
                <div class="form-email">
                    <label class="label-14" for="email">E-MAIL</label>
                    <input id="email" type="text" name="email" v-model="this.contents.email" disabled>
                </div>

                <div v-if="!envBermudes && !envComptoirMaritime">

                    <!-- OFFRES PROMO CODE  3-->
                    <div class="arm-pBT">
                        <span class="arm-info arm-label-checkbox" v-if="!envARLDE">Les offres, promotions, actualités et Ventes Privées:</span>
                        <span class="arm-info arm-label-checkbox" v-if="envARLDE" >Angebote, Sonderaktionen, Neuheiten und exklusive VIP Verkäufe:</span>

                        <input type="radio" id="yes" v-bind:value=true v-model="this.contents.newsletterArmor">
                        <label class="arm-label-radio-button" for="yes">Oui</label>

                        <input type="radio" id="no" v-bind:value=false v-model="this.contents.newsletterArmor">
                        <label class="arm-label-radio-button" for="no">Non</label>
                    </div>

                    <!-- PROGRAMME FIDELITE CODE  10 -->
                    <div class="arm-pBT">
                        <label id="arm-label-fid" for="name" class="arm-info arm-label-checkbox" v-if="!envARLDE">
                            Les informations concernant mon programme de fidélité <br>(solde de points, remises, bon d'achat anniversaire):
                        </label>
                        <label id="arm-label-fid" for="name" class="arm-info arm-label-checkbox" v-if="envARLDE" >
                            Informationen über mein Treueprogramm <br>(Punktestand, Treuerabatt, Geburtstagsgutschein):
                        </label>

                        <input type="radio" v-bind:value=true v-model="this.contents.fidelite">
                        <label for="Oui" class="arm-label-radio-button">Oui</label>

                        <input type="radio" v-bind:value=false v-model="this.contents.fidelite">
                        <label for="Non" class="arm-label-radio-button">Non</label>

                    </div>

                    <!-- ANNIVERSAIRE PROCHAINE VERSION-->
                    <!-- <div class="form-group form-anniversaire">
                        <p class="arm-info">
                            Pour recevoir votre bon anniversaire, merci de compléter votre date de naissance:
                        </p>

                        <label class="label-14" for="dateAnniversaire">Date d'anniversaire </label>
                        <input
                        id="dateAnniversaire"
                        type="date"
                        v-model="state.formUser.dateAnniversaire">
                        <div id="calendar-inside-input">
                            <font-awesome-icon icon="calendar-alt" />
                        </div> 
                    </div> -->

                    <!-- VENTES PRIVEES CODE  4 -->
                    <div v-if="this.disabledCourrier != 1 && this.$route.params.c == 'c=ARLFR'">
                        <h4 id="arm-label-vente-privee" style="" v-if="!envARLDE">
                            <label class="arm-label-checkbox">Je souhaite recevoir par courrier les Ventes Privées et les autres offres:</label>
                        </h4>
                        <h4 id="arm-label-vente-privee" style="" v-if="envARLDE">
                            <label class="arm-label-checkbox">Ich möchte per Post über Privatverkäufe und andere Angebote informiert werden:</label>
                        </h4>

                        <input type="radio" :value="true" v-model="this.contents.courrier"
                            :disabled="disabledCourrier == 1">
                        <label for="Oui" class="arm-label-radio-button">Oui</label>

                        <input type="radio" :value="false" v-model="this.contents.courrier"
                            :disabled="disabledCourrier == 1">
                        <label for="Non" class="arm-label-radio-button">Non</label>
                    </div>

                    <!-- OFFRES SMS CODE  6-->
                    <div v-if="this.disabledSMS != 1 && this.$route.params.c == 'c=ARLFR'">
                        <h4 id="arm-label-offres-sms" v-if="!envARLDE">
                            <label class="arm-label-checkbox" >Je souhaite recevoir par SMS les offres, promotions, actualités et Ventes Privées:</label>
                        </h4>
                        <h4 id="arm-label-offres-sms"  v-if="envARLDE">
                            <label class="arm-label-checkbox">Ich möchte per SMS über Angebote, Sonderangebote, aktuelle Informationen und Privatverkäufe informiert werden: </label>
                        </h4>

                        <input type="radio" class="radio-button-sms" v-bind:value="true" v-model="this.contents.sms" :disabled="disabledSMS == 1">
                        <label for="Oui" class="arm-label-radio-button radio-button-sms">Oui</label>

                        <input type="radio" class="radio-button-sms" v-bind:value="false" v-model="this.contents.sms" :disabled="disabledSMS == 1">
                        <label for="Non" class="arm-label-radio-button">Non</label>
                    </div>

                    <!-- INPUT MOBILE -->
                    <!-- PROCHAINE VERSION 
                    <div v-if="state.formUser.radioSMS == 'true'">

                        <div class="form-group">
                            <label  class="label-14" for="mobile" :class="{ 'is-required' : v$.formUser.mobile.$error }" ><span>*</span>Mobile (France Métropolitaine)  </label>
                            <input  id="mobile" type="text"  name="mobile"  v-model="state.formUser.mobile" placeholder="00" :class="{ 'is-required' : v$.formUser.mobile.$error }" >
                            <div class="label-error" v-for="error in v$.formUser.mobile.$errors" :key="error.$uid" >
                                <div v-if="error.$message!='Value is required'" > 
                                    {{ error.$message }}
                                </div>
                            </div>
                        </div>

                        informations 
                        <p class="arm-info">
                            Les champs marqués d'une <span>*</span> sont obliagtoires.
                        </p>

                    </div>
                    -->
                </div>

                <!-- BERMUDES -->
                <div v-if="envBermudes && this.contents.newsletterBermudes != undefined">

                    <!-- NEWSLETTER CODE 15-->
                    <div class="arm-pBT">
                        <span class="arm-info arm-label-checkbox" v-if="!envARLDE">Les offres, promotions, actualités et Ventes Privées:</span>
                        <span class="arm-info arm-label-checkbox" v-if="envARLDE" >Angebote, Sonderaktionen, Neuheiten und exklusive VIP Verkäufe:</span>

                        <input type="radio" id="yes" v-bind:value=true v-model="this.contents.newsletterBermudes">
                        <label class="arm-label-radio-button" for="yes">Oui</label>

                        <input type="radio" id="no" v-bind:value=false v-model="this.contents.newsletterBermudes">
                        <label class="arm-label-radio-button" for="no">Non</label>
                    </div>
                </div>

                <!-- COMPTOIR MARITIME -->
                <div v-if="envComptoirMaritime && this.contents.newsletterComptoirMaritime != undefined">
                    <div class="arm-pBT">
                        <span class="arm-info arm-label-checkbox" v-if="!envARLDE">Les offres, promotions, actualités et Ventes Privées:</span>
                        <span class="arm-info arm-label-checkbox" v-if="envARLDE" >Angebote, Sonderaktionen, Neuheiten und exklusive VIP Verkäufe:</span>

                        <input type="radio" id="yes" v-bind:value=true v-model="this.contents.newsletterComptoirMaritime">
                        <label class="arm-label-radio-button" for="yes">Oui</label>

                        <input type="radio" id="no" v-bind:value=false v-model="this.contents.newsletterComptoirMaritime">
                        <label class="arm-label-radio-button" for="no">Non</label>
                    </div>
                </div>


                <div style="position:relative">

                    <button class="arm-button" type="submit"
                        :class="{ isInvalid: v$.formUser.mobile.$error && state.formUser.radioSMS != false }"
                        :disabled="v$.formUser.mobile.$error && state.formUser.radioSMS != false"> 
                        <text v-if="!envARLDE">Enregistrer </text>
                        <text v-if="envARLDE">
                            Speichern
                        </text>
                    </button>

                    <div v-if="v$.formUser.mobile.$errors && state.formUser.radioSMS != false">
                        <div v-for="error in v$.formUser.mobile.$errors" :key="error.$uid">
                            <div id="arm-bloc-champs-obl" v-if="error.$message == 'Value is required'">
                                <p  v-if="!envARLDE" >Merci de remplir les champs obligatoires</p>
                                <p  v-if="envARLDE" >Merci de remplir les champs obligatoires</p>
                            </div>
                        </div>
                    </div>

                </div>

                <div v-if="loading">
                    <span  v-if="!envARLDE">
                        Chargement...
                    </span>
                    <span v-if="envARLDE">
                        Laden...
                    </span>
                </div>

                <EngagementRGPD :engagement="engagement" :envARLDE="envARLDE"/>
            </form>

        </div>
    </div>
</template>

<script>

import useValidate from '@vuelidate/core'
import { helpers } from '@vuelidate/validators'
import { reactive, computed } from 'vue'
import { getUser, postData } from '../services/UserService'
import ButtonReturnSite from './ButtonReturnSite.vue';
import EngagementRGPD from './EngagementRGPD.vue';
import Error from './Error.vue';

export default {
    name: 'FormAbonnement',
    components: {
        ButtonReturnSite,
        EngagementRGPD,
        Error
    },
    setup() {
        const state = reactive({
            formUser: {
                email: '',
                radioOffres: true,
                radioFidelite: true,
                radioSMS: false,
                radioCourrier: true,
                //dateAnniversaire:''
                //mobile:''
            },
            disabled: true,
        })
        const checkMobileFormat = helpers.regex(/^(0)(6|7)[0-9]{8}$/);
        const rules = computed(() => {
            return {
                formUser: {
                    mobile: {
                        checkMobileFormat: helpers.withMessage('Attention, le format de votre mobile n’est pas reconnu.', checkMobileFormat)
                    },
                }
            }
        })
        const v$ = useValidate(rules, state)
        const submitForm = async () => {

        };
        return {
            state,
            v$,
            submitForm
        }        
    },
    data() {
        return {
            loading: false,
            erroredSend: false,
            errored: false,
            disabledSMS: 0,
            disabledCourrier: 0,
            contents: [],
            dataToSend: {
                codeClient: '',
                email: '',
                optins: '',
                codeLangue: 'FR',
            },
            dataSend: false,
            envBermudes: false,
            envARLDE: false,
            envARLFR: true,
            envComptoirMaritime: false,
            engagement: '',
            lienRetourSite: ''
        }
    },
    created() {
        this.fetchData()

        if (this.envBermudes) {
            this.lienRetourSite = "https://www.bermudes.com/"
            this.engagement = "Bermudes"

        } else if (this.envComptoirMaritime) {
            this.lienRetourSite = "https://lecomptoirmaritime.com/"
            this.engagement = "Le comptoir Maritime"

        } else {
            this.lienRetourSite = "https://www.armorlux.com"
            this.engagement = "Armor-lux"
        }
    },
    mounted() {
        this.getUser()
    },
    methods: {
        getUser() {
            getUser().then(response => {
                this.contents = response;
                console.log("Content : ", this.contents);
                if (response.newsletterBermudes != '' || response.newsletterBermudes != undefined) {
                    if (this.contents.newsletterBermudes.toString().toLowerCase() == 'oui') {
                        this.contents.newsletterBermudes = true;
                    }
                    if (this.contents.newsletterBermudes.toString().toLowerCase() == 'non') {
                        this.contents.newsletterBermudes = false;
                    }
                }

                if (response.newsletterComptoirMaritime != '' || response.newsletterComptoirMaritime != undefined) {
                    if (this.contents.newsletterComptoirMaritime.toString().toLowerCase() == 'oui') {
                        this.contents.newsletterComptoirMaritime = true;
                    }
                    if (this.contents.newsletterComptoirMaritime.toString().toLowerCase() == 'non') {
                        this.contents.newsletterComptoirMaritime = false;
                    }

                    
                }

                this.disabledData()
            }).catch(error => {
                console.error(error)
                this.errored = true
            }).finally(() => this.loading = false);
        },
        fetchData() {
            this.loading = true
            if (this.$route.params.c != '') {
                this.c = this.$route.params.c
                if(this.$route.params.c == 'c=ARLDE') {
                    this.envARLDE = true;
                }
            }

            if (this.$route.params.i != '' && this.$route.params.i != 0) {
                this.i = this.$route.params.i
                if (this.$route.params.c == 'c=BERFR') {
                    this.envBermudes = true;
                }

                if (this.$route.params.c == 'c=CMFR') {
                    this.envComptoirMaritime = true;
                }
            }

            if (this.$route.params.m != '') {
                this.m = this.$route.params.m
            }

            if (this.$route.params.p != '' && this.$route.params.p != 0) {
                this.p = this.$route.params.p
            }

        },
        postData() {
            this.loading = true;
            this.dataToSend.codeClient = this.contents.codeClient;
            this.dataToSend.email = this.contents.email;
            this.dataToSend.optins = [
                {
                    'id': '3',
                    'valeur': this.contents.newsletterArmor,
                },
                {
                    'id': '4',
                    'valeur': this.contents.courrier ? this.contents.courrier : 0,
                },
                {
                    'id': '6',
                    'valeur': this.contents.sms ? this.contents.sms : 0,
                },
                {
                    'id': '10',
                    'valeur': this.contents.fidelite,
                },
                {
                    'id': '15',
                    'valeur': this.contents.newsletterBermudes,
                },
                {
                    'id' : '33',
                    'valeur' : this.contents.newsletterComptoirMaritime
                }
            ];

            postData(this.dataToSend)
            .then((response) => console.log('response', response))
            .catch(function (error) {
                console.error(error)
                this.errored = true
            }).finally(() => this.dataSend=true );
        },
        disabledData() {
            if (this.contents.sms == false) {
                this.disabledSMS = 1
            }
            if (this.contents.courrier == false) {
                this.disabledCourrier = 1;
            }
            if (this.contents.fidelite == false) {
                this.disabledFidelite = 1;
            }
            if (this.contents.newsletterArmor == false) {
                this.disabledNewsletterArmor = 1;
            }

        }
    },

};
</script>


<style scoped>
/*** GLOBAL */
input[type='radio'] {
    accent-color: var(--color-heading);
    border: var(--color-heading);
    color: var(--color-heading);
}

span {
    color: var(--vt-c-red);
    font-size: 18px;
    vertical-align: middle;
    margin-right: 2px;
    font-family: "CabinetGrotesk-Bold", sans-serif;
}


/***** */

.label-14 {
    font-size: 14px;
    color: var(--color-heading);
    font-family: "CabinetGrotesk-Bold", sans-serif;
    text-transform: uppercase;
    margin-bottom: 10px;
    text-align: left;
    display: block
}

.label-error {
    font-size: 12px;
    color: var(--vt-c-red-light);
    font-family: "CabinetGrotesk-Regular", sans-serif;
    margin-bottom: 0px;
    margin-top: -20px;
    margin-left: 1px;
    text-align: left;
    display: block
}

.label-14.is-required {
    color: var(--vt-c-red-light);
}

.arm-info {
    font-size: 14px;
    font-weight: 400;
    color: var(--color-heading);
    font-family: "CabinetGrotesk-Regular", sans-serif;
    padding: 10px 0px;
}

.arm-info-italic {
    font-style: italic;
}

.arm-label-radio-button {
    font-size: 14px;
    font-weight: 400;
    color: var(--color-heading);
    font-family: "CabinetGrotesk-Regular", sans-serif;
    margin-right: 15px;
    margin-left: 10px;
}

.arm-label-checkbox {
    margin-right: 130px;
}

.arm-radio-button {
    margin-right: 15px
}

#arm-form-desabo #arm-first-title {
    margin-top: 0px;
    font-family: "CabinetGrotesk-Bold", sans-serif;

}

#arm-label-fid {
    margin-right: 102px;
}

#email,
#dateAnniversaire,
#mobile {
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    background-color: #f2f2f2;
    color: var(--color-heading);
    font-family: "CabinetGrotesk-Regular", sans-serif;
    line-height: 20px;
    padding: 8px 15px;
    font-size: 14px;
    line-height: 1.571;
    min-width: 320px;
    margin-bottom: 25px;
    cursor: pointer;
}

#email {
    cursor: default;
}

#dateAnniversaire {
    background-color: #fff;
}

#dateAnniversaire::placeholder {
    text-transform: uppercase;
}

#mobile {
    background-color: #fff;
}

#mobile.is-required {
    border: 1px solid var(--vt-c-red-light) !important;
}

#calendar-inside-input {
    display: inline-block;
    margin-left: -30px;
    background-color: #f2f2f2;
    padding: 8px;
    cursor: pointer;
}

.form-anniversaire p.arm-info {
    padding-bottom: 10px;
}

.arm-pBT {
    padding-bottom: 20px;
}

/******* BUTTON */
a.arm-button {
    margin-top: 20px;
    padding: 10px 45px;
}

.arm-button {
    transition: all .3s cubic-bezier(0.52, 0.12, 0.05, 0.95);
    background-color: var(--color-heading);
    color: #fff;
    text-transform: uppercase;
    font-family: "CabinetGrotesk-Bold", sans-serif;
    border-radius: 45px;
    box-shadow: none;
    padding: 8px 45px;
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 500;
    line-height: 25px;
    border: 1px solid transparent;
    cursor: pointer;
    position: relative;
}

.arm-button:hover {
    background-color: var(--vt-c-gris);
    color: var(--vt-c-background-color);
}

a.arm-button:hover {
    text-decoration: none;
}

#arm-bloc-champs-obl {
    display: inline-block;
    text-align: center;
    position: absolute;
    top: 5px;
    z-index: 9999;
}

#arm-bloc-champs-obl p {
    color: white;
    background-color: var(--vt-c-background-color);
    line-height: 14px;
    font-family: "CabinetGrotesk-Regular", sans-serif;
    border-radius: 45px;
    box-shadow: none;
    padding: 7px 20px;
    font-size: 12px;
    text-transform: initial;
    max-width: 200px;
}

#arm-bloc-champs-obl p::before {
    content: '';
    position: absolute;
    top: -6px;
    left: 46%;
    width: 0;
    height: 0;
    border-bottom: 6px solid rgba(0, 0, 0, .9);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
}

.arm-button-disabled {
    cursor: not-allowed;
    opacity: 0.8;
    cursor: default;
    background-color: var(--vt-c-gris-soft);
    color: var(--vt-c-gris);
}

#arm-label-offres-sms,
#arm-label-vente-privee {
    display: inline-block;
    font-family: "CabinetGrotesk-Bold", sans-serif;
}

#arm-label-vente-privee .arm-label-checkbox {
    margin-right: 130px;
}

#arm-label-offres-sms .arm-label-checkbox {
    margin-right: 50px;
}

.arm-button.isInvalid {
    background-color: var(--vt-c-gris-soft);
    color: var(--vt-c-gris)
}


/** RESPONSIV MEDIA  */
@media (max-width: 991px) {
    .arm-label-checkbox {
        margin-right: 38px;
    }

    #arm-label-fid {
        margin-right: 10px;
    }

    .arm-pBT {
        padding-bottom: 10px;
    }

    .arm-button {
        margin-top: 40px;
    }
}

@media (max-width: 600px) {
    .arm-label-checkbox {
        display: block;
        margin-bottom: 0px;
        padding-bottom: 0px;
        margin-right: 0px;
    }

    #arm-label-vente-privee .arm-label-checkbox,
    #arm-label-offres-sms .arm-label-checkbox {
        margin-right: 0px;
    }

    #arm-label-fid {
        display: block;
    }

    h4 {
        margin-bottom: 0px;
        padding-bottom: 0px;
    }

    .arm-button {
        margin-top: 20px;
    }

    #arm-form-desabo br {
        display: none;
    }
}</style>